export const numberOfNights = (start: Date, end: Date): number => {
  const startDay = new Date(start.setHours(0, 0, 0, 0));
  const endDay = new Date(end.setHours(0, 0, 0, 0));
  const differenceInDays = endDay.getTime() - startDay.getTime();
  return Math.floor(differenceInDays / (24 * 60 * 60 * 1000));
};
